import {download} from 'services/utils/misc'
import {IconButton} from '@mui/material'
import {useGetPlannerClientPdfsQuery} from 'store/Store'
import {Colors, Icons} from 'appearance'

const Report = ({rowData}) => {
    const {PdfUrl, XlsxUrl} = rowData
    const {data: pdf} = useGetPlannerClientPdfsQuery(
        {pdfUrl: PdfUrl},
        {skip: !PdfUrl}
    )
    const {data: xlsx} = useGetPlannerClientPdfsQuery(
        {pdfUrl: XlsxUrl},
        {skip: !XlsxUrl}
    )

    const pdfFileName = PdfUrl?.split('/').pop()
    const xlsxFileName = XlsxUrl?.split('/').pop()
    return (
        <div>
            {PdfUrl && (
                <IconButton
                    onClick={() => download(pdf?.base64, pdfFileName)}
                    sx={{p: 0}}>
                    <Icons.Pdf color={Colors.PDF_ICON} width={30} height={30} />
                </IconButton>
            )}
            {XlsxUrl && (
                <IconButton
                    onClick={() => download(xlsx?.base64, xlsxFileName)}
                    sx={{p: 0, mr: '10px'}}>
                    <Icons.Excel sx={{fontSize: 10}} width={25} height={25} />
                </IconButton>
            )}
        </div>
    )
}

export default Report
